import { Box, Button, LinearProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Activity } from "./Activity";
import { MyListApi } from "../utils/restApi";
import { addNotification } from "../slices/notificationSlice";
import AdSlot from "./AdSlot";

export const Activities = () => {

    const user = useSelector(state => state.login.user);
    const dispatch = useDispatch();
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    // const [pageLoaded, setPageLoaded] = useState(-1);
    const [maxPages, setMaxPages] = useState(0);

    useEffect(() => {
        if (loading) return;
        setLoading(true);
        MyListApi.getActivities(page)
            .then(response => {
                setActivities(prev => [...prev, ...response.items]);
                setMaxPages(response.maxPageCount);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }, [page, user]);

    const handleMoreResults = () => {
        setPage(prev => prev + 1);
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
            {/* <AdSlot height={90} /> */}
            {activities.map((a, ix) => <Activity activity={a} key={a.id || ix} />)}
            {loading && <LinearProgress />}
            {!loading && activities.length === 0 ? <Typography color="text.secondary">No activity yet.</Typography> : null}
            {page < (maxPages - 1) ? <Button variant="outlined" onClick={handleMoreResults} disabled={loading}>More results</Button> : null}
        </Box>
    );
}